import { InterventionCategory } from '@/types';
import { useParams } from 'react-router-dom';

type NewInterventionUrl = {
  category: string;
};

const useNewInterventionCategory: () => InterventionCategory = () => {
  const params = useParams<NewInterventionUrl>();
  return params.category as InterventionCategory;
};

export { useNewInterventionCategory };
